var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from "vue-property-decorator";
import { Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SystemToolsService } from "~/services/domain-service/system-tools.service";
var FilingStep = /** @class */ (function (_super) {
    __extends(FilingStep, _super);
    function FilingStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // 弹框控制
        _this.dialog = {
            isOpenDetail: false
        };
        _this.selectedRow = {};
        _this.tableData = [];
        _this.queryParam = {
            stype: 1,
            name: "",
            id: "",
            pageNum: 1,
            url: "",
            hfApiCallType: ""
        };
        _this.prevPageUrl = "";
        _this.nextPageUrl = "";
        _this.totalNumber = 0;
        _this.currentNum = 0;
        return _this;
    }
    FilingStep.prototype.onPageInfoChange = function (val) {
        var _this = this;
        if (!val) {
            this.clearInfo();
            return;
        }
        if (this.tableData === []) {
            this.clearInfo();
        }
        console.log("数据查询", this.queryParam, this.pageInfo);
        this.queryParam = this.pageInfo;
        this.systemToolsService
            .queryRiskFxContent(this.queryParam)
            .subscribe(function (data) {
            if (!data)
                return;
            _this.tableData = data.detail;
            _this.prevPageUrl = data.prevUrl;
            _this.nextPageUrl = data.nextUrl;
            _this.currentNum = data.currentPage;
            _this.totalNumber = data.fxmsgNum;
        });
    };
    FilingStep.prototype.clearInfo = function () {
        this.tableData = [];
        this.prevPageUrl = "";
        this.nextPageUrl = "";
        this.currentNum = 1;
        this.totalNumber = 0;
        this.selectedRow = {};
        this.dialog.isOpenDetail = false;
        this.queryParam = {
            stype: 1,
            name: "",
            id: "",
            pageNum: 1,
            url: "",
            hfApiCallType: ""
        };
    };
    FilingStep.prototype.prevClick = function () {
        console.log("上一页");
        if (this.prevPageUrl === "") {
            return;
        }
        this.queryRiskFxContent(this.prevPageUrl, -1);
    };
    FilingStep.prototype.nextClick = function () {
        console.log("下一页");
        if (this.nextPageUrl === "") {
            return;
        }
        this.queryRiskFxContent(this.nextPageUrl, 1);
    };
    FilingStep.prototype.queryRiskFxContent = function (url, offsex) {
        var _this = this;
        this.queryParam.url = url;
        this.queryParam.pageNum = this.queryParam.pageNum + offsex;
        this.systemToolsService
            .queryRiskFxContent(this.queryParam)
            .subscribe(function (data) {
            if (!data)
                return;
            _this.tableData = data.detail;
            _this.prevPageUrl = data.prevUrl;
            _this.nextPageUrl = data.nextUrl;
            _this.currentNum = data.currentPage;
        });
    };
    FilingStep.prototype.emitViewDetail = function (row) {
        this.dialog.isOpenDetail = true;
        this.selectedRow = row;
    };
    __decorate([
        Dependencies(PageService)
    ], FilingStep.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SystemToolsService)
    ], FilingStep.prototype, "systemToolsService", void 0);
    __decorate([
        Prop()
    ], FilingStep.prototype, "pageInfo", void 0);
    __decorate([
        Prop()
    ], FilingStep.prototype, "isReload", void 0);
    __decorate([
        Watch("isReload", { immediate: true })
    ], FilingStep.prototype, "onPageInfoChange", null);
    FilingStep = __decorate([
        Component({
            components: {}
        })
    ], FilingStep);
    return FilingStep;
}(Vue));
export default FilingStep;
